/* eslint-disable no-param-reassign */
/* eslint-disable no-async-promise-executor */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-30 11:02:25
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-26 15:30:59
 * @FilePath: /roboneo-web/src/api/canvasRquest.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApi } from '@meitu/catalyze';
import { useOfficialStore } from '$/store/useOfficialStore';
import { useLanguageStore } from '$/store/languageStore';
import { getTaskStatusEnum } from '$/utils/taskStatus';
import useVipModalStore, { loggleVipModal, openVipModal } from '$/store/useVipModalStore';
import { message } from '$/components/Message';
import { addCommonHeaders, type RoboneoRequestConfig } from './helpers';
import { createLoggingMiddleware } from './middlewares/loggingMiddleware';
import { createRequestErrorMiddleware } from './middlewares/createRequestErrorMiddleware';
import { isAxiosNetworkError, notifyRequestNetworkErrorOnce } from './utils/resolveRequestErrorMessage';
import { getErrorMsgByNoAmount } from './server';
// import { checkMeiyeAmount } from './server';

import {
  DeleteLayerParams, SaveLayerParams, LayerItemResult, TaskCategory, TaskQueryResult, ModifyTextParams,
  FontFamilyItem, SubmitFeedbackParams, InpaintParams, EditImagePriceItem, ExtendImagePrams, CardsParams,
  EraserParams, CardsResult,
  FusionImageParams,
  ActivityList,
  CheckAIFaceParams,
  PopupInfoResponse,
  CommonConfigParams,
  HotPromptItem,
  AssetFolderType,
  AssetFolderListResponse,
  AssetFolderDownloadSubmitParams,
  AssetFolderDownloadSubmitResponse,
  AssetFolderDownloadStatusResponse,
  AssetListParams,
  AssetSearchParams,
  AssetListResponse,
  AssetCreateParams,
  AssetBatchActionType,
  MediaLibraryFolderCreateParams,
  MediaLibraryFolderCreateResponse,
  MediaLibraryFolderMoveParams,
  MediaLibraryFolderMoveResponse,
  MediaLibraryFolderMoveStatusResponse,
  MediaLibraryFolderTreeResponse,
  MediaLibraryItemBatchActionParams,
  MediaLibraryItem,
  MediaLibraryItemListParams,
  MediaLibraryItemListResponse,
  MediaLibraryItemSaveParams,
  MediaLibraryItemSaveResponse,
  MediaLibraryStorageUsageResponse,
  TeamStorageInfoResponse,
  TeamStorageContactSaveParams,
  OfficialAssetListData,
  OfficialAssetMaterialInfoData,
  OfficialAssetMaterialListData,
  OfficialAssetMaterialListParams,
  OfficialAssetServerCategory,
  OfficialAssetServerGenre,
  OfficialAssetServerTagGroup,
  SeedanceSubmitParams,
  SeedanceTaskItem,
  SeedanceListData,
  SeedanceLivenessSessionCreateResult,
  SeedanceLivenessNotifyResult,
  SeedanceLivenessSessionStatusResult,
  SeedancePortraitFolderCreateParams,
  SeedancePortraitFolderDeleteParams,
  SeedancePortraitFolderItem,
  SeedancePortraitFolderListData,
  SeedancePortraitFolderRenameParams,
  SeedancePortraitUploadParams,
  SeedancePortraitUploadResult,
  SeedanceComplianceLibraryListParams,
  SeedanceComplianceLibraryListData,
  SeedanceComplianceLibraryItem,
  SeedanceComplianceLibraryUploadParams,
  SeedanceComplianceLibraryUploadResult,
  SeedanceComplianceUploadStatusParams,
  SeedanceComplianceUploadStatusResult,
  SeedanceComplianceLibraryDeleteParams,
  CanvasMaterialLightingListResponse,
  CanvasPromptTemplateListParams,
  CanvasPromptTemplateListResponse,
} from './server.types';
import type { RoboneoApiOptions } from './request';
import APP from './api';

export type RoboneoCanvasApiOptions = Pick<RoboneoApiOptions, 'canvasMiddlewareConfig'>;
let canvasRequestApi: ReturnType<typeof createApi> | undefined;

export interface CanvasServerFetchOptions {
  method: string;
  url: string;
  params?: Record<string, any>;
  data?: Record<string, any>;
  headers?: Record<string, string>;
  timeout?: number;
}

/**
 * 获取 canvas 接口公共参数，保持服务端 fallback 与客户端拦截器一致。
 */
function getCanvasCommonParams() {
  const {
    currentCountryCode, clientId, gid,
  } = useOfficialStore.getState();
  const { languageCode } = useLanguageStore.getState().languageStore;
  return {
    gnum: gid,
    client_id: clientId,
    client_language: languageCode,
    country_code: currentCountryCode,
  };
}

/**
 * 处理协议相对 canvas 域名，供服务端 fetch 构造绝对 URL。
 */
function getCanvasServerBaseUrl() {
  const baseUrl = APP.roboneo.baseCanvasURL();
  return baseUrl.startsWith('//') ? `https:${baseUrl}` : baseUrl;
}

/**
 * canvasRequestApi 未初始化时的服务端请求兜底，返回 axios-like 响应结构。
 */
async function serverFetch(options: CanvasServerFetchOptions) {
  const {
    method = 'GET',
    url,
    params = {},
    data = {},
    headers = {},
    timeout = 30000,
  } = options;
  const upperMethod = method.toUpperCase();
  const commonParams = getCanvasCommonParams();
  const requestUrl = new URL(url, getCanvasServerBaseUrl());
  const queryParams = upperMethod === 'GET' ? { ...commonParams, ...params } : params;

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      requestUrl.searchParams.set(key, String(value));
    }
  });

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  const fetchOptions: RequestInit = {
    method: upperMethod,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    signal: controller.signal,
  };

  if (upperMethod !== 'GET') {
    fetchOptions.body = JSON.stringify({
      ...commonParams,
      ...data,
    });
  }

  try {
    const response = await fetch(requestUrl.toString(), fetchOptions);
    const responseText = await response.text();
    const responseData = responseText ? JSON.parse(responseText) : null;
    return {
      data: responseData,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config: options,
    };
  } finally {
    clearTimeout(timeoutId);
  }
}

const createCanvasApi = (options: RoboneoCanvasApiOptions) => {
  const { errorMiddleware, logging = true, commonParamsHeadersMiddleware = {} } = options.canvasMiddlewareConfig || {};

  canvasRequestApi = createApi({
    baseURL: APP.roboneo.baseCanvasURL(),
    withCredentials: true,
    timeout: 30000,
    transformResponse: [
      // 转换data字符串
      function transform(data: any) {
        if (data && data instanceof ArrayBuffer) {
          return data;
        }

        return data;
      },
    ],
  });

  canvasRequestApi.modifyApiInstance((api) => {
    api.interceptors.request.use(
      async (config) => {
      // 打印完整的请求信息
      // console.log('canvasRequest Details:', {
      //   url: config.url,
      //   baseURL: config.baseURL,
      //   fullUrl: `${config.baseURL}${config.url}`,
      //   method: config.method,
      //   headers: config.headers,
      //   // 如果是开发环境，打印代理信息
      //   isDev: process.env.NEXT_PUBLIC_ENV === 'development',
      //   proxyPath: '/dev-proxy/roboneoApi',
      //   actualApiUrl: process.env.NEXT_PUBLIC_REBONEO_CANVAS_SERVER_URL,
      // });
        const {
          currentCountryCode, clientId, gid,
        } = useOfficialStore.getState();
        const { languageCode } = useLanguageStore.getState().languageStore;
        const commonParams = {
          gnum: gid,
          client_id: clientId,
          client_language: languageCode,
          country_code: currentCountryCode,
        };
        if (!config.data) {
          config.data = {};
        }
        config.data = {
          ...commonParams,
          ...config.data,
        };
        if (config?.method === 'get') {
          config.params = {
            ...commonParams,
            ...config.params,
          };
        }
        await addCommonHeaders(config);
        return config;
      },
      (err: any) => {
        // eslint-disable-next-line no-console
        console.log(err, '请求失败');
        return err;
      },
    );

    // 构建中间件数组
    const middlewares: any[] = [createRequestErrorMiddleware()];

    // 根据配置添加中间件
    if (logging !== false) {
      const { env } = useOfficialStore.getState();
      middlewares.push(createLoggingMiddleware(env === 'development'));
    }
    if (Object.keys(commonParamsHeadersMiddleware)?.length) {
      middlewares.push(commonParamsHeadersMiddleware);
    }
    middlewares.push(errorMiddleware?.());

    api.interceptors.request.use(
      (config) => {
        return middlewares.reduce((cfg, middleware) => {
          return middleware.onRequest ? middleware.onRequest(cfg) || cfg : cfg;
        }, config);
      },
      (error) => {
        middlewares.forEach((mw) => mw?.onError && mw?.onError(error));
        return Promise.reject(error);
      },
    );

    api.interceptors.response.use(
      (response) => {
        // 在成功响应后自动查询剩余额度
        if (response.config?.url && response.config.url.includes(APP.roboneo.api.taskSubmit)) {
          const { updateAmountCb } = useVipModalStore.getState();
          // 重置订阅的状态
          loggleVipModal(false);
          // 异步调用额度查询，不阻塞当前请求
          setTimeout(() => {
            updateAmountCb?.();
            // checkMeiyeAmount().catch((error) => {
            //   console.warn('额度查询失败:', error);
            // });
          }, 3000);
        }
        return middlewares.reduce((resp, middleware) => {
          return middleware.onResponse ? middleware.onResponse(resp) || resp : resp;
        }, response);
      },
      (error) => {
        middlewares.forEach((mw) => mw.onError && mw.onError(error));
        return Promise.reject(error);
      },
    );
  });
};

const canvasRequest = {
  request: async (options: RoboneoRequestConfig<any>) => {
    // 服务端环境：canvasRequestApi 未初始化，使用 serverFetch
    if (!canvasRequestApi) {
      return serverFetch({
        method: (options.method?.toUpperCase() as any) || 'GET',
        url: options.url || '',
        params: options.params,
        data: options.data,
        headers: options.headers as Record<string, string>,
      });
    }
    // 客户端环境：使用 axios 实例
    return canvasRequestApi.request(options);
  },
};

/** 素材库读取作用域；personal 会在当前团队态下显式移除 Client-OID。 */
export interface MediaLibraryRequestOptions {
  scope?: 'current' | 'personal';
}

// 更新图层信息
export async function saveLayer(params: SaveLayerParams) {
  const response = await canvasRequest.request({
    data: {
      ...params,
    },
    method: 'POST',
    url: APP.roboneo.api.saveLayer,
  });
  return response;
}

// 删除图层信息
export async function deleteLayer(params: DeleteLayerParams) {
  const response = await canvasRequest.request({
    data: {
      ...params,
    },
    method: 'POST',
    url: APP.roboneo.api.deleteLayer,
  });
  return response;
}

// 查询图层列表
export async function fetchLayerList(room_id: string): Promise<{ list: LayerItemResult[]; }> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        room_id,
      },
      method: 'GET',
      url: APP.roboneo.api.layerList,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// 初始化room
export async function initRoom(room_id: string, from_room_id?: string) {
  const response = await canvasRequest.request({
    data: {
      room_id,
      from_room_id,
    },
    method: 'POST',
    url: APP.roboneo.api.initRoom,
  });
  return response;
}

/**
 * 创建图片分层任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {string} image_file
 * @return {*}  {Promise<{ id: string; }>}
 */
export async function createLayeringTask(room_id: string, layer_id: string, image_file: string): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify({ image_file }),
        layer_id,
        task_category: TaskCategory.LAYERING,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建AI超清任务
 *
 * @export
 * @param {CreateTaskParams<AISuperParams>} {
 *   room_id, task_category, params,
 * }
 * @return {*}
 */
export async function creatAISuperTask(room_id: string, layer_id: string, image_file: string, alpha_status: number[]): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify({ image_file, alpha_status }),
        layer_id,
        task_category: TaskCategory.MAGICSR,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}
/**
 * 创建扣图任务
 *
 * @export
 * @param {CreateTaskParams<CutOutParams>} {
 *   room_id, task_category, params,
 * }
 * @return {*}
 */
export async function creatCutOutTask(room_id: string, layer_id: string, init_image: string): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify({ init_image }),
        layer_id,
        task_category: TaskCategory.CUTOUT,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建改图任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {InpaintParams} params
 * @return {*}  {Promise<{ id: string; }>}
 */
export async function createModifyTask(room_id: string, layer_id: string, task_category: TaskCategory, params: InpaintParams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify(params),
        layer_id,
        task_category,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建改字任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {TaskCategory} task_category
 * @param {ModifyTextParams} params
 * @return {*}  {Promise<{ id: string; }>}
 */
export async function createModifyTextTask(room_id: string, layer_id: string, task_category: TaskCategory, params: ModifyTextParams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify(params),
        layer_id,
        task_category,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建AI消除任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {EraserParams} params
 * @return {*}  {Promise<{ id: string; }>}
 */
export async function createEraserTask(room_id: string, layer_id: string, task_category: TaskCategory, params: EraserParams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify(params),
        layer_id,
        task_category,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建扩图任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {ExtendImagePrams} params
 * @return {*}  {Promise<{ id: string; }>}
 */
export async function creatExtendTask(room_id: string, layer_id: string, params: ExtendImagePrams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify(params),
        layer_id,
        task_category: TaskCategory.EXTEND,
      },
      method: 'POST',
      url: APP.roboneo.api.taskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}
/**
 * 创建融图任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {FusionImageParams} params
 * @return {*}  {Promise<{ id: string; }>}
 */

export async function createFusionImageTask(room_id: string, layer_id: string, params: FusionImageParams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify(params),
        layer_id,
        task_category: TaskCategory.FUSION,
      },
      method: 'POST',
      url: APP.roboneo.api.fusionImageTaskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 查询任务
 * @export
 * @param {string} room_id
 * @param {string} ids
 * @return {*}
 */
export async function taskQuery(room_id: string, ids: string): Promise<TaskQueryResult[]> {
  const { updateAmountCb } = useVipModalStore.getState();
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        room_id,
        ids,
      },
      method: 'GET',
      url: APP.roboneo.api.taskQuery,
    });

    if (response.status === 200 && response.data.code === 0) {
      const result = Array.isArray(response.data.data) && response.data.data.length ? response.data.data?.[0] : {};
      if (result.status === 95) {
        const responce = await getErrorMsgByNoAmount(result.id);
        openVipModal?.('topright_page', responce?.reduce_fail_guide);
      }
      // 画布操作更新萝卜时机，外部宿主定义
      if (getTaskStatusEnum(result.status) !== 'polling') {
        updateAmountCb?.();
      }
      resolve(response.data.data);
      return;
    }

    reject(response);
  });
}

/**
 * 创建AI降噪任务
 *
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {FusionImageParams} params
 * @return {*}  {Promise<{ id: string; }>}
 */

export async function createAudioDenoiseTask(room_id: string, layer_id: string, params: { audio_file: string; }): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify(params),
        layer_id,
        task_category: TaskCategory.AUDIO_DENOISE,
      },
      method: 'POST',
      url: APP.roboneo.api.audioDenoiseTaskSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 查询字体列表
 *
 * @export
 * @return {*}  {Promise<TaskQueryResult[]>}
 */
export async function fetchFontList(count = 20): Promise<{
  cursor: string;
  list: FontFamilyItem[];
  default_font: FontFamilyItem;
}> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { count },
      method: 'GET',
      url: APP.roboneo.api.fontList,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

export async function fetchLightingMaterialList(count = 8): Promise<CanvasMaterialLightingListResponse> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { count },
      method: 'GET',
      url: APP.roboneo.api.canvasMaterialLightingListV3,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取画布底部输入框提示词模板列表。
 */
export async function fetchPromptTemplateList(
  params: CanvasPromptTemplateListParams = { visible_only: 1 },
): Promise<CanvasPromptTemplateListResponse> {
  const response = await canvasRequest.request({
    params: {
      visible_only: 1,
      ...params,
    },
    method: 'GET',
    url: APP.roboneo.api.canvasPromptTemplateListV3,
  });
  if (response.status === 200 && response.data.code === 0) {
    return response.data.data;
  }
  return Promise.reject(response);
}

/**
 * 查询任务列表,只查询未使用并制作中或成功的
 *
 * @export
 * @param {string} room_id
 * @return {*}  {Promise<{ list: TaskQueryResult[]; }>}
 */
export async function fetchTaskList(room_id: string): Promise<{ list: TaskQueryResult[]; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      // use_status 任务在画布中的使用状态，1-未使用，2-使用
      // task_status 任务状态，1-生成中，2-生成成功，3-生成失败
      params: { room_id, use_status: '1', task_status: '1,2' },
      method: 'GET',
      url: APP.roboneo.api.taskList,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建任务标记
 *
 * @export
 * @param {string} room_id
 * @param {string} msg_id
 * @return {*}  {Promise<{ result: boolean; }>}
 */
export async function createTaskMark(room_id: string, msg_id: string): Promise<{ result: boolean; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        msg_id,
      },
      method: 'POST',
      url: APP.roboneo.api.taskMark,
    });
    console.log('fetchTaskList response', response);

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 提交反馈
 *
 * @export
 * @param {SubmitFeedbackParams} data
 * @return {*}
 */
export async function submitFeedback(data: SubmitFeedbackParams) {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data,
      method: 'POST',
      url: APP.roboneo.api.feedback,
    });
    console.log('fetchTaskList response', response);

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 查询编辑图片价格
 *
 * @export
 * @return {*}
 */
export async function checkEditImagePrice(): Promise<{
  web_items: EditImagePriceItem[];
}> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {},
      method: 'GET',
      url: APP.roboneo.api.checkEditImagePrice,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建png转svg任务
 *
 * @export
 * @param {string[]} init_images
 * @return {*}
 */
export function pngToSvgImage(room_id: string, init_images: string[]): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        params: JSON.stringify({ init_images }),
        task_category: TaskCategory.PNG2SVG,
      },
      method: 'POST',
      url: APP.roboneo.api.pngToSvg,
    });

    if (response.status === 200 && response.data.code === 0) {
      loggleVipModal(false);
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 首页卡片列表 （热门案例）
 *
 * @export
 * @param {CardsParams} params
 * @return {*}
 */
export async function getHomeCards(params: CardsParams) {
  return new Promise<CardsResult>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        ...params,
        scene: 'web',
      },
      method: 'GET',
      url: APP.roboneo.api.cards,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取弹窗信息
 *
 * @return {*}  {Promise<PopupInfoResponse>}
 */
export async function getPopupInfo(
  params?: { position: 'home'; },
): Promise<PopupInfoResponse>
{
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params,
      method: 'GET',
      url: APP.roboneo.api.commonConfig,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

export async function fetchActivityList(): Promise<ActivityList> {
  try {
    const res = await canvasRequestApi?.request({
      method: 'GET',
      url: APP.roboneo.api.activityList,
    });
    return res?.data.data;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * 是否显示sora卡片
 *
 * @export
 * @return {*}  {Promise<{
 *   show: boolean;
 * }>}
 */
export async function getSoraStatus(): Promise<CommonConfigParams> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {},
      method: 'GET',
      url: APP.roboneo.api.commonConfig,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 通过 IP 解析获取用户地理位置信息
 */
export async function getIpResolution() {
  const { gid } = useOfficialStore.getState();
  const response = await canvasRequest.request({
    params: { source: 'homepage', gid },
    method: 'GET',
    url: APP.roboneo.api.ipResolution,
  });
  if (response.status === 200 && response.data.code === 0) {
    return response.data.data;
  }
  return Promise.reject(response);
}

/**
 * 人脸检测
 * https://insight-mtlab.meitu-int.com/doc/919
 * @export
 * @param {string} room_id
 * @param {string} layer_id
 * @param {CheckAIFaceParams} params
 * @return {*}  {Promise<{ id: string; }>}
 */
export function checkAIFace(room_id: string, layer_id: string, params: CheckAIFaceParams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        room_id,
        layer_id,
        params: JSON.stringify(params),
        task_category: TaskCategory.AI_FACE,
      },
      method: 'POST',
      url: APP.roboneo.api.checkAiFace,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

export async function homeFeatureLike({ card_id, action }: { card_id: number; action: 'like' | 'unlike'; }) {
  try {
    const res = await canvasRequestApi?.request(
      {
        method: 'GET',
        url: APP.roboneo.api.homeFeatureLike,
        params: {
          card_id,
          action,
        },
      },
    );
    return res?.data;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * 获取热门prompt列表
 *
 * @export
 * @param {number} categoryId 分类ID
 * @return {*}  {Promise<{ list: HotPromptItem[] }>}
 */
export async function getHomePrompts(categoryId: number): Promise<{ list: HotPromptItem[]; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { category_id: categoryId },
      method: 'GET',
      url: APP.roboneo.api.homePrompt,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// ========== 资产库 API ==========

/**
 * 解析资产相关接口返回的 message，供 toast 使用
 * @param m 响应体 message 字段
 * @returns 去掉首尾空白后的非空字符串，否则 null
 */
function pickAssetLibraryApiMessage(m: unknown): string | null {
  if (typeof m === 'string') {
    const t = m.trim();
    return t.length ? t : null;
  }
  return null;
}

/**
 * 解析资产库接口返回的业务 code，供多语言错误提示映射使用。
 */
function pickAssetLibraryApiCode(c: unknown): number | null {
  const code = Number(c);
  return Number.isFinite(code) ? code : null;
}

/**
 * 将资产库文件夹移动接口 code 映射为远端 Smartcat 已下发文案；未覆盖的 code 继续走服务端 message。
 */
function translateAssetLibraryApiCodeMessage(code: unknown): string | null {
  const n = pickAssetLibraryApiCode(code);
  const translate = useLanguageStore.getState().languageStore.smartcatTranslationText;
  switch (n) {
    case 15101:
      return translate((v) => v.cannot_move_to_self_foldercannot_move_to_self_folder);
    case 15102:
      return translate((v) => v.cannot_move_to_sub);
    case 15103:
      return translate((v) => v.already_in_this_directory);
    case 15104:
      return translate((v) => v.duplicate_folder_name_in_target_dir);
    case 15105:
      return translate((v) => v.folder_depth_limit_exceeded_cannot_move);
    case 15106:
      return translate((v) => v.folder_not_exist);
    case 15108:
      return translate((v) => v.task_creation_failed);
    case 15109:
      return translate((v) => v.only_one_first_level_folder_cannot_move);
    // 15107（任务不存在）暂无 Smartcat 文案，继续回退服务端 message
    default:
      return null;
  }
}

/**
 * 从资产库响应体里优先按 code 翻译，缺省时回退 message。
 */
function extractAssetLibraryApiMessageFromBody(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const body = data as { code?: unknown; message?: unknown; };
  return translateAssetLibraryApiCodeMessage(body.code) ?? pickAssetLibraryApiMessage(body.message);
}

/**
 * 从 axios 成功响应或请求异常中取出业务 JSON 的 message（与 { code, message, reqid } 等形态一致）
 * @param errOrResponse 成功时为 AxiosResponse；HTTP 非 2xx 时为 AxiosError（文案在 error.response.data）
 */
function extractAssetLibraryApiMessageFromUnknown(errOrResponse: unknown): string | null {
  if (typeof errOrResponse !== 'object' || errOrResponse === null) return null;
  const o = errOrResponse as Record<string, unknown>;
  if ('response' in o && o.response && typeof o.response === 'object' && o.response !== null) {
    const { data } = o.response as { data?: unknown; };
    const t = extractAssetLibraryApiMessageFromBody(data);
    if (t) return t;
  }
  if ('data' in o) {
    return extractAssetLibraryApiMessageFromBody(o.data);
  }
  return null;
}

/**
 * 业务失败时：有 message 则 error toast，并在对象上打标
 * @param errOrResponse 同上
 */
function notifyAssetLibraryFailureOnce(errOrResponse: unknown): void {
  const text = extractAssetLibraryApiMessageFromUnknown(errOrResponse);
  if (!text) return;
  message.error(text);
  if (typeof errOrResponse === 'object' && errOrResponse !== null) {
    (errOrResponse as { assetLibraryApiMessageShown?: boolean; }).assetLibraryApiMessageShown = true;
  }
}

/**
 * 资产接口已在请求层用 data.message 弹出 toast 时，业务 catch 中勿再 message.error 兜底。
 * @param err catch 到的值
 * @returns 是否已展示过后端返回文案
 */
export function isAssetLibraryApiMessageShown(err: unknown): boolean {
  return typeof err === 'object' && err !== null
    && (err as { assetLibraryApiMessageShown?: boolean; }).assetLibraryApiMessageShown === true;
}

/**
 * HTTP 200 但 code !== 0 等业务失败
 * @param response axios 完整响应
 */
function rejectAssetLibraryResponse(response: unknown): Promise<never> {
  notifyAssetLibraryFailureOnce(response);
  return Promise.reject(response);
}

/**
 * 同上，用于 throw 分支
 * @param response axios 完整响应
 */
function throwAssetLibraryResponse(response: unknown): never {
  notifyAssetLibraryFailureOnce(response);
  throw response;
}

/**
 * 包裹 await request 的 catch：避免 throwAssetLibraryResponse 二次 toast；并处理 HTTP 错误体里的 message
 * @param err catch 到的错误
 */
function rejectAssetLibraryCaughtError(err: unknown): Promise<never> {
  if (isAssetLibraryApiMessageShown(err)) {
    return Promise.reject(err);
  }
  notifyRequestNetworkErrorOnce(err, (key) => message.error(key));
  if (isAxiosNetworkError(err)) {
    return Promise.reject(err);
  }
  notifyAssetLibraryFailureOnce(err);
  return Promise.reject(err);
}

/**
 * 同上，用于 void 类接口的 catch
 * @param err catch 到的错误
 */
function throwAssetLibraryCaughtError(err: unknown): never {
  if (isAssetLibraryApiMessageShown(err)) {
    throw err;
  }
  notifyRequestNetworkErrorOnce(err, (key) => message.error(key));
  if (isAxiosNetworkError(err)) {
    throw err;
  }
  notifyAssetLibraryFailureOnce(err);
  throw err;
}

interface CreateAssetFolderParams {
  name: string;
  folder_type?: AssetFolderType;
  room_id?: string;
}

interface GetAssetFolderListParams {
  folder_type?: AssetFolderType;
}

interface OfficialAssetApiEnvelope<T> {
  code: number;
  message?: string;
  data: T;
}

/**
 * 资产列表 GET 参数与后端约定：folder_id、分页、only_favorited 等为整数；created_by_uid 保留为数字字符串以兼容 int64
 * @param params 调用方查询参数
 * @returns 浅拷贝后的参数；非法 folder_id / created_by_uid 会被移除，其余数字字段仅在有限数字时写入 Number
 */
function normalizeAssetListParams(params?: AssetListParams): AssetListParams {
  if (!params) return {};
  const out: AssetListParams = { ...params };
  if (out.folder_id != null) {
    const n = Number(out.folder_id);
    if (Number.isFinite(n)) out.folder_id = n;
    else delete out.folder_id;
  }
  if (out.created_by_uid != null) {
    const uid = String(out.created_by_uid).trim();
    if (/^\d+$/.test(uid)) out.created_by_uid = uid;
    else delete out.created_by_uid;
  }
  if (out.page != null) {
    const n = Number(out.page);
    if (Number.isFinite(n)) out.page = n;
  }
  if (out.page_size != null) {
    const n = Number(out.page_size);
    if (Number.isFinite(n)) out.page_size = n;
  }
  if (out.only_favorited != null) {
    const n = Number(out.only_favorited);
    if (Number.isFinite(n)) out.only_favorited = n;
  }
  return out;
}

/**
 * 资产搜索 POST 请求体：`keyword` 原样保留，与列表接口相同的字段做数字归一化
 * @param params 搜索参数（须含 keyword）
 * @returns 供请求体使用的浅拷贝
 */
function normalizeAssetSearchParams(params: AssetSearchParams): AssetSearchParams {
  const { keyword, ...listPart } = params;
  return {
    keyword,
    ...normalizeAssetListParams(listPart),
  };
}

/** 文件夹列表（侧边栏展示） */
export async function getAssetFolderList(params?: GetAssetFolderListParams): Promise<AssetFolderListResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.assetLibraryFolderList,
      params: { ...(params ?? {}), folder_type: params?.folder_type ?? 'normal' },
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/** 新建文件夹 */
export async function createAssetFolder(name: string): Promise<{ folder_id: number; }>;
export async function createAssetFolder(params: CreateAssetFolderParams): Promise<{ folder_id: number; }>;
export async function createAssetFolder(
  name_or_params: string | CreateAssetFolderParams,
): Promise<{ folder_id: number; }> {
  const data: CreateAssetFolderParams = typeof name_or_params === 'string'
    ? { name: name_or_params }
    : name_or_params;
  if (data.folder_type === 'room' && !data.room_id) {
    return Promise.reject(new Error('createAssetFolder: room 类型必须传 room_id'));
  }

  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryFolderCreate,
      data,
    });
    if (response.status === 200 && response.data.code === 0) {
      const raw = response.data.data as { folder_id?: unknown; };
      return { folder_id: Number(raw.folder_id) };
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/** 重命名文件夹（folder_id 统一为整数，与资产库接口约定一致） */
export async function renameAssetFolder(folder_id: number, name: string): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryFolderRename,
      data: { folder_id: Number(folder_id), name },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/** 置顶/取消置顶文件夹 */
export async function pinAssetFolder(folder_id: number, is_pinned: 0 | 1): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryFolderPin,
      data: { folder_id: Number(folder_id), is_pinned },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/** 删除文件夹 */
export async function deleteAssetFolder(folder_id: number): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryFolderDelete,
      data: { folder_id: Number(folder_id) },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 按文件夹或指定资产 ID 下载压缩包（异步提交打包任务，返回 task_id 后可轮询 download_status）
 * @param folder_id_or_params 传数字等价于 `{ folder_id }`；与后端约定：folder_id 与 asset_ids（非空）二选一
 */
export async function downloadAssetFolder(
  folder_id_or_params: number | AssetFolderDownloadSubmitParams,
): Promise<AssetFolderDownloadSubmitResponse> {
  /** GET 查询串：后端要求 asset_ids 为逗号分隔，不能传数组（axios 默认序列化后端不认） */
  let params: Record<string, string | number>;
  if (typeof folder_id_or_params === 'number') {
    params = { folder_id: Number(folder_id_or_params) };
  } else if ('asset_ids' in folder_id_or_params) {
    const ids = folder_id_or_params.asset_ids;
    if (!ids?.length) {
      return Promise.reject(new Error('downloadAssetFolder: asset_ids 不能为空'));
    }
    params = { asset_ids: ids.join(',') };
    if (folder_id_or_params.with_watermark != null) {
      params.with_watermark = folder_id_or_params.with_watermark;
    }
    if (folder_id_or_params.aigc != null) {
      params.aigc = folder_id_or_params.aigc;
    }
  } else {
    params = { folder_id: Number(folder_id_or_params.folder_id) };
    if (folder_id_or_params.with_watermark != null) {
      params.with_watermark = folder_id_or_params.with_watermark;
    }
    if (folder_id_or_params.aigc != null) {
      params.aigc = folder_id_or_params.aigc;
    }
  }
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.assetLibraryFolderDownload,
      params,
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/** 查询文件夹下载任务状态（轮询；status 为 success 时返回 download_url） */
export async function getAssetFolderDownloadStatus(task_id: string): Promise<AssetFolderDownloadStatusResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.assetLibraryFolderDownloadStatus,
      params: { task_id },
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/** 资产列表（素材列表，支持筛选） */
export async function getAssetList(params?: AssetListParams): Promise<AssetListResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.assetLibraryAssetList,
      params: normalizeAssetListParams(params),
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 资产库关键词搜索（POST `/asset_library/asset/search.json`），响应结构与 `getAssetList` 一致
 * @param params 搜索关键词及与列表一致的筛选、分页；`client_id` / `client_language` / `gnum` 等由画布请求拦截器写入请求体
 */
export async function searchAssets(params: AssetSearchParams): Promise<AssetListResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetSearch,
      data: normalizeAssetSearchParams(params),
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 创建资产（用户端，画布/工作流/工具结果写入资产库）
 * @param params 含可选 width、height（像素）、duration（秒）等媒体元信息；可选 `name`（展示用原始文件名）；可选 task_id、source_scene（仅 task_generate | import，其它值后端报参数错误）；可选 room_id、room_name
 */
export async function createAsset(params: AssetCreateParams): Promise<{ asset_id: number; }> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetCreate,
      data: params,
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/** 收藏/取消收藏资产 */
export async function starAsset(asset_id: number, is_favorited: 0 | 1): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetStar,
      data: { asset_id, is_favorited },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/** 删除资产（单个，请求体 `asset_id`） */
export async function deleteAsset(asset_id: number): Promise<void>;
/** 删除资产（批量，请求体 `asset_ids`） */
export async function deleteAsset(asset_ids: number[]): Promise<void>;
/**
 * 删除资产：单个传 `asset_id`，批量传 `asset_ids`（与后端 `asset_ids []uint64` 一致）。
 */
export async function deleteAsset(input: number | number[]): Promise<void> {
  const data = typeof input === 'number' ? { asset_id: input } : { asset_ids: input };
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetDelete,
      data,
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/** 添加资产到文件夹（统一将 id 转为 number，避免接口返回 string 时 JSON 里 folder_id 带引号导致后端解析失败） */
export async function addAssetToFolder(asset_ids: number[], folder_id: number): Promise<void> {
  const folderIdNum = Number(folder_id);
  const assetIdsNum = asset_ids.map((id) => Number(id));
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetAddToFolder,
      data: { asset_ids: assetIdsNum, folder_id: folderIdNum },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/** 从文件夹移除资产（id 与 addAssetToFolder 一致做数值化，避免 string 序列化问题） */
export async function removeAssetFromFolder(asset_ids: number[], folder_id: number): Promise<void> {
  const folderIdNum = Number(folder_id);
  const assetIdsNum = asset_ids.map((id) => Number(id));
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetRemoveFromFolder,
      data: { asset_ids: assetIdsNum, folder_id: folderIdNum },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/** 批量操作：star / unstar / delete / add_to_folder / remove_from_folder；add_to_folder / remove_from_folder 传 target_folder 时须为整数 */
export async function batchActionAsset(
  asset_ids: number[],
  action_type: AssetBatchActionType,
  target_folder?: number,
): Promise<void> {
  const data: { asset_ids: number[]; action_type: AssetBatchActionType; target_folder?: number; } = {
    asset_ids: asset_ids.map((id) => Number(id)),
    action_type,
  };
  if (
    (action_type === 'add_to_folder' || action_type === 'remove_from_folder')
    && target_folder !== undefined
  ) {
    data.target_folder = Number(target_folder);
  }
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.assetLibraryAssetBatchAction,
      data,
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 素材库列表 GET 参数规范化：普通数值字段转 number，成员 UID 保留数字字符串以兼容 int64。
 */
function normalizeMediaLibraryItemListParams(params?: MediaLibraryItemListParams): MediaLibraryItemListParams {
  if (!params) return {};
  const out: MediaLibraryItemListParams = { ...params };
  if (out.folder_id != null) {
    const n = Number(out.folder_id);
    if (Number.isFinite(n)) out.folder_id = n;
    else delete out.folder_id;
  }
  if (out.created_by_uid != null) {
    const uid = String(out.created_by_uid).trim();
    if (/^\d+$/.test(uid)) out.created_by_uid = uid;
    else delete out.created_by_uid;
  }
  if (out.page != null) {
    const n = Number(out.page);
    if (Number.isFinite(n)) out.page = n;
  }
  if (out.page_size != null) {
    const n = Number(out.page_size);
    if (Number.isFinite(n)) out.page_size = n;
  }
  return out;
}

/**
 * 获取素材库文件夹树；首次调用会触发服务端懒初始化 6 个系统默认文件夹。
 */
export async function getMediaLibraryFolderTree(
  options?: MediaLibraryRequestOptions,
): Promise<MediaLibraryFolderTreeResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.mediaLibraryFolderTree,
      skipClientOId: options?.scope === 'personal',
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 创建素材库文件夹，parent_id=0 表示根下。
 */
export async function createMediaLibraryFolder(
  params: MediaLibraryFolderCreateParams,
): Promise<MediaLibraryFolderCreateResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryFolderCreate,
      data: {
        parent_id: Number(params.parent_id ?? 0),
        name: params.name,
      },
    });
    if (response.status === 200 && response.data.code === 0) {
      const raw = response.data.data as { folder_id?: unknown; };
      return { folder_id: Number(raw.folder_id) };
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 重命名素材库文件夹。
 */
export async function renameMediaLibraryFolder(folder_id: number, name: string): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryFolderRename,
      data: { folder_id: Number(folder_id), name },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 删除素材库文件夹，后端会级联软删子文件夹和其中素材。
 */
export async function deleteMediaLibraryFolder(folder_id: number): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryFolderDelete,
      data: { folder_id: Number(folder_id) },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 移动素材库文件夹；跨父级移动和同级调序统一使用 target_parent_id + sort_order，省略 sort_order 时服务端追加到末尾。
 */
export async function moveMediaLibraryFolder(
  params: MediaLibraryFolderMoveParams,
): Promise<MediaLibraryFolderMoveResponse | null> {
  try {
    const data: Record<string, number> = {
      folder_id: Number(params.folder_id),
      target_parent_id: Number(params.target_parent_id),
    };
    if (params.sort_order != null) {
      data.sort_order = Number(params.sort_order);
    }
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryFolderMove,
      data,
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data ?? null;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 查询素材库文件夹异步移动状态；仅在 move 返回 async=true 时调用。
 */
export async function getMediaLibraryFolderMoveStatus(
  task_id: string,
): Promise<MediaLibraryFolderMoveStatusResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.mediaLibraryFolderMoveStatus,
      params: { task_id },
    });
    if (response.status === 200 && response.data.code === 0) {
      const data = response.data.data as Partial<MediaLibraryFolderMoveStatusResponse> | null | undefined;
      const status = String(data?.status || '');
      if (status === 'pending' || status === 'running' || status === 'done' || status === 'failed') {
        return { status, message: data?.message };
      }
      return { status: 'failed', message: data?.message || '文件夹移动状态异常' };
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 团队存储容量超限错误
 * 当写入资产库时容量不足，抛出此错误供调用方捕获并展示拦截弹窗
 */
export class StorageExceededError extends Error {
  public readonly storageInfo: TeamStorageInfoResponse;

  public readonly requiredBytes: number;

  constructor(storageInfo: TeamStorageInfoResponse, requiredBytes: number) {
    super('Team storage exceeded');
    this.name = 'StorageExceededError';
    this.storageInfo = storageInfo;
    this.requiredBytes = requiredBytes;
  }
}

/**
 * 查询团队存储额度信息
 */
export async function getTeamStorageInfo(): Promise<TeamStorageInfoResponse> {
  const response = await canvasRequest.request({
    method: 'GET',
    url: APP.roboneo.api.teamStorageInfo,
  });
  if (response.status === 200 && response.data.code === 0) {
    return response.data.data as TeamStorageInfoResponse;
  }
  throw new Error('Failed to get team storage info');
}

/**
 * 判断当前是否处于团队态；团队容量接口只允许团队空间主动调用。
 */
function isTeamEditionActive(): boolean {
  return Boolean(useOfficialStore.getState().clientOId);
}

/**
 * 保存团队存储联系信息（黑金会员提交邮箱）
 * @param params 联系信息参数，包含 email、required_bytes、scene
 */
export async function saveTeamStorageContact(params: TeamStorageContactSaveParams): Promise<void> {
  const response = await canvasRequest.request({
    method: 'POST',
    url: APP.roboneo.api.teamStorageContactSave,
    data: params,
  });
  if (response.status === 200 && response.data.code === 0) {
    return;
  }
  throw new Error(response.data?.message || useLanguageStore.getState()
    .languageStore.smartcatTranslationText((v) => v.submit_contact_info_failed));
}

/**
 * 保存 TeamFlow 生成或上传素材到 v3.1 素材库。
 * 团队态写入前会校验团队存储容量，容量不足时抛出 StorageExceededError；个人态不调用团队容量接口。
 */
export async function saveMediaLibraryItem(
  params: MediaLibraryItemSaveParams,
): Promise<MediaLibraryItemSaveResponse> {
  try {
    // 团队容量接口仅在团队空间调用，个人空间直接交给保存接口处理。
    const fileSize = Number(params.file_size) || 0;
    if (fileSize > 0 && isTeamEditionActive()) {
      const storageInfo = await getTeamStorageInfo();
      // 直接检查剩余空间是否足够
      if (fileSize > storageInfo.remain_bytes) {
        throw new StorageExceededError(storageInfo, fileSize);
      }
    }

    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryItemSave,
      data: {
        ...params,
        folder_id: Number(params.folder_id),
        ...(params.file_size != null ? { file_size: Number(params.file_size) } : {}),
      },
    });
    if (response.status === 200 && response.data.code === 0) {
      const raw = response.data.data as { item_id?: unknown; };
      return { item_id: Number(raw.item_id) };
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    // StorageExceededError 直接向上抛出，不走通用错误处理
    if (err instanceof StorageExceededError) {
      throw err;
    }
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 按素材库 item_id 查询单个素材；接口参数名 asset_id 由后端约定沿用。
 */
export async function getMediaLibraryItem(assetId: number): Promise<MediaLibraryItem | null> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.mediaLibraryItemGet,
      params: { asset_id: Number(assetId) },
    });
    if (response.status === 200 && response.data.code === 0) {
      const data = response.data.data as { exists?: boolean; item?: MediaLibraryItem | null; } | null;
      if (!data || data.exists === false || !data.item) {
        return null;
      }
      return data.item;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 更新素材库素材；更新参数与 save 保持一致，并额外带后端要求的 asset_id。
 */
export async function updateMediaLibraryItem(params: MediaLibraryItemSaveParams & { asset_id: number; }): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryItemUpdate,
      data: {
        ...params,
        asset_id: Number(params.asset_id),
        folder_id: Number(params.folder_id),
        ...(params.file_size != null ? { file_size: Number(params.file_size) } : {}),
      },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 获取素材库素材列表，folder_id=0 或不传表示全部。
 */
export async function getMediaLibraryItemList(
  params?: MediaLibraryItemListParams,
  options?: MediaLibraryRequestOptions,
): Promise<MediaLibraryItemListResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.mediaLibraryItemList,
      params: normalizeMediaLibraryItemListParams(params),
      skipClientOId: options?.scope === 'personal',
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/**
 * 重命名素材库素材。
 */
export async function renameMediaLibraryItem(item_id: number, name: string): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryItemRename,
      data: { item_id: Number(item_id), name },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 删除单个素材库素材。
 */
export async function deleteMediaLibraryItem(item_id: number): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryItemDelete,
      data: { item_id: Number(item_id) },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 批量删除或移动素材库素材；move 时 target_folder 必填。
 */
export async function batchActionMediaLibraryItem(params: MediaLibraryItemBatchActionParams): Promise<void> {
  try {
    const response = await canvasRequest.request({
      method: 'POST',
      url: APP.roboneo.api.mediaLibraryItemBatchAction,
      data: {
        action_type: params.action_type,
        item_ids: params.item_ids.map((id) => Number(id)),
        ...(params.target_folder != null ? { target_folder: Number(params.target_folder) } : {}),
      },
    });
    if (response.status === 200 && response.data.code === 0) {
      return;
    }
    throwAssetLibraryResponse(response);
  } catch (err) {
    throwAssetLibraryCaughtError(err);
  }
}

/**
 * 获取当前用户素材库主文件字节占用。
 */
export async function getMediaLibraryStorageUsage(): Promise<MediaLibraryStorageUsageResponse> {
  try {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.mediaLibraryStorageUsage,
    });
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data;
    }
    return await rejectAssetLibraryResponse(response);
  } catch (err) {
    return rejectAssetLibraryCaughtError(err);
  }
}

/** 请求官方资产库 WebAPI，并统一抽取后端 envelope 中的 data。 */
async function requestOfficialAssetData<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  const response = await canvasRequest.request({
    method: 'GET',
    url,
    params,
  }) as { status: number; data: OfficialAssetApiEnvelope<T>; };

  if (response.status === 200 && response.data.code === 0) {
    return response.data.data;
  }

  throw new Error(response.data.message || useLanguageStore.getState()
    .languageStore.smartcatTranslationText((v) => v.official_asset_library_request_failed));
}

/** 根据已选标签生成服务端约定的 material[key][]=value 查询串。 */
function buildOfficialAssetMaterialFilterQuery(filters?: Record<string, string[]>): string {
  const searchParams = new URLSearchParams();

  Object.entries(filters ?? {}).forEach(([groupKey, values]) => {
    values.forEach((value) => {
      if (value) {
        searchParams.append(`material[${groupKey}][]`, value);
      }
    });
  });

  return searchParams.toString();
}

/** 获取官方资产一级分类列表。 */
export async function getOfficialAssetCategoryList(): Promise<OfficialAssetListData<OfficialAssetServerCategory>> {
  return requestOfficialAssetData<OfficialAssetListData<OfficialAssetServerCategory>>(
    APP.roboneo.api.officialAssetCategoryList,
  );
}

/** 获取官方资产一级分类下的题材列表。 */
export async function getOfficialAssetGenreList(
  code: string,
): Promise<OfficialAssetListData<OfficialAssetServerGenre>> {
  return requestOfficialAssetData<OfficialAssetListData<OfficialAssetServerGenre>>(
    APP.roboneo.api.officialAssetGenreList,
    { code },
  );
}

/** 获取官方资产题材对应的标签筛选组。 */
export async function getOfficialAssetTagList(params: {
  code: string;
  genre: string;
}): Promise<OfficialAssetListData<OfficialAssetServerTagGroup>> {
  return requestOfficialAssetData<OfficialAssetListData<OfficialAssetServerTagGroup>>(
    APP.roboneo.api.officialAssetTagList,
    params,
  );
}

/** 获取官方素材列表，使用服务端 cursor 分页并叠加标签和关键词条件。 */
export async function getOfficialAssetMaterialList({
  genre_id,
  count,
  cursor = '',
  filters,
  keyword,
}: OfficialAssetMaterialListParams): Promise<OfficialAssetMaterialListData> {
  const filterQuery = buildOfficialAssetMaterialFilterQuery(filters);
  const url = filterQuery
    ? `${APP.roboneo.api.officialAssetMaterialList}?${filterQuery}`
    : APP.roboneo.api.officialAssetMaterialList;

  return requestOfficialAssetData<OfficialAssetMaterialListData>(url, {
    genre_id,
    count,
    cursor,
    keyword: keyword || undefined,
  });
}

/** 根据素材 id 获取官方素材详情，资源不存在时 data 中不返回 info。 */
export async function getOfficialAssetMaterialInfo(id: number): Promise<OfficialAssetMaterialInfoData> {
  return requestOfficialAssetData<OfficialAssetMaterialInfoData>(
    APP.roboneo.api.officialAssetMaterialInfo,
    { id },
  );
}

// ========== Seedance API ==========

/**
 * 提交 Seedance 生视频任务（需登录）
 */
export async function seedanceSubmit(params: SeedanceSubmitParams): Promise<{ id: string; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: { ...params },
      method: 'POST',
      url: APP.roboneo.api.seedanceSubmit,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 批量查询 Seedance 任务（ids 逗号分隔）
 */
export async function seedanceQuery(ids: string): Promise<SeedanceTaskItem[]> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { ids },
      method: 'GET',
      url: APP.roboneo.api.seedanceQuery,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data ?? []);
      return;
    }
    reject(response);
  });
}

/**
 * Seedance 任务列表（当前用户、未软删除、id 倒序）
 */
export async function seedanceList(params?: { cursor?: number; count?: number; }): Promise<SeedanceListData> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        cursor: params?.cursor ?? 0,
        count: params?.count ?? 20,
      },
      method: 'GET',
      url: APP.roboneo.api.seedanceList,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 软删除 Seedance 任务（仅终态可删）
 */
export async function seedanceDelete(id: string): Promise<{ result: boolean; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { id },
      method: 'GET',
      url: APP.roboneo.api.seedanceDelete,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建 Seedance 真人人像活体检测 session，返回三方 H5 的扫码地址。
 */
export async function seedanceCreateLivenessSession(params: { redirect_url: string; }): Promise<SeedanceLivenessSessionCreateResult> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: { ...params },
      method: 'POST',
      url: APP.roboneo.api.seedanceLivenessSessionCreate,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 查询 Seedance 真人人像活体检测 session 状态，成功时服务端会返回可用于生成的 group_id。
 */
export async function seedanceGetLivenessSessionStatus(sessionId: string): Promise<SeedanceLivenessSessionStatusResult> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { session_id: sessionId },
      method: 'GET',
      url: APP.roboneo.api.seedanceLivenessSessionStatus,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 上报三方 H5 回跳参数并落库活体检测结果，参数需要和 redirect query 保持一致。
 */
export async function seedanceNotifyLivenessResult(params: Record<string, string>): Promise<SeedanceLivenessNotifyResult> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params,
      method: 'GET',
      url: APP.roboneo.api.seedanceLivenessNotify,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 创建 Seedance 真人人像文件夹，必须在活体 session 成功后调用。
 */
export async function seedanceCreatePortraitFolder(params: SeedancePortraitFolderCreateParams): Promise<SeedancePortraitFolderItem> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: params,
      method: 'POST',
      url: APP.roboneo.api.seedancePortraitFolderCreate,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 获取当前用户已创建的 Seedance 真人人像文件夹。
 */
export async function seedanceListPortraitFolders(): Promise<SeedancePortraitFolderItem[]> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.seedancePortraitFolderList,
    });
    if (response.status === 200 && response.data.code === 0) {
      const data = response.data.data as SeedancePortraitFolderListData | SeedancePortraitFolderItem[] | undefined;
      resolve(Array.isArray(data) ? data : data?.list ?? []);
      return;
    }
    reject(response);
  });
}

/**
 * 删除 Seedance 真人人像文件夹，接口要求 folder_id 为 number。
 */
export async function seedanceDeletePortraitFolder(params: SeedancePortraitFolderDeleteParams): Promise<{ result?: boolean; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        folder_id: Number(params.folder_id),
      },
      method: 'POST',
      url: APP.roboneo.api.seedancePortraitFolderDelete,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 重命名 Seedance 真人人像文件夹，接口要求 folder_id 为 number。
 */
export async function seedanceRenamePortraitFolder(params: SeedancePortraitFolderRenameParams): Promise<{ result?: boolean; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        folder_id: Number(params.folder_id),
        name: params.name,
      },
      method: 'POST',
      url: APP.roboneo.api.seedancePortraitFolderRename,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 上传 Seedance 真人人像参考图，返回 upload_id 后由前端轮询同人校验结果。
 */
export async function seedanceUploadPortraitImages(params: SeedancePortraitUploadParams): Promise<SeedancePortraitUploadResult> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        ...params,
        folder_id: Number(params.folder_id),
      },
      method: 'POST',
      url: APP.roboneo.api.seedancePortraitUpload,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 查询 Seedance 合规素材上传后的异步校验状态，人像与图/视/音共用该接口。
 */
export async function seedanceGetComplianceUploadStatus(params: SeedanceComplianceUploadStatusParams): Promise<SeedanceComplianceUploadStatusResult> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params,
      method: 'GET',
      url: APP.roboneo.api.seedanceComplianceUploadStatus,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 按 tab 拉取 Seedance 合规素材列表；只有人像夹详情会传 folder_id。
 */
export async function seedanceListComplianceLibrary(params: SeedanceComplianceLibraryListParams): Promise<SeedanceComplianceLibraryItem[]> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: {
        page: 1,
        page_size: 50,
        ...params,
      },
      method: 'GET',
      url: APP.roboneo.api.seedanceComplianceLibraryList,
    });
    if (response.status === 200 && response.data.code === 0) {
      const data = response.data.data as SeedanceComplianceLibraryListData | SeedanceComplianceLibraryItem[] | undefined;
      resolve(Array.isArray(data) ? data : data?.list ?? []);
      return;
    }
    reject(response);
  });
}

/**
 * 上传 Seedance 普通图/视/音素材，按接口约束不携带 folder_id。
 */
export async function seedanceUploadComplianceLibrary(params: SeedanceComplianceLibraryUploadParams): Promise<SeedanceComplianceLibraryUploadResult> {
  return new Promise(async (resolve, reject) => {
    const shouldSendCompressUrl = params.compress_url?.some(Boolean);
    const response = await canvasRequest.request({
      data: {
        tab_type: params.tab_type,
        urls: params.urls,
        ...(shouldSendCompressUrl ? { compress_url: params.compress_url } : {}),
      },
      method: 'POST',
      url: APP.roboneo.api.seedanceComplianceLibraryUpload,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 删除 Seedance 合规素材库条目，当前 UI 需要时可按 item_id 直接调用。
 */
export async function seedanceDeleteComplianceLibraryItem(params: SeedanceComplianceLibraryDeleteParams): Promise<{ result?: boolean; }> {
  return new Promise(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: params,
      method: 'POST',
      url: APP.roboneo.api.seedanceComplianceLibraryDelete,
    });
    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

export { createCanvasApi, canvasRequest };
